<ng-container *ngIf="activated && panel.isVisible">
  <ng-container *ngFor="let section of sectionDefinitions">
    <ng-container *ngIf="!section.hidden">
      <ng-container [ngSwitch]="section.type">
        <ng-container *ngSwitchCase="'list'">
          <lm-list
            #LMListComponent
              [listUrlInfo]="section.url"
              [listSpec]="section.spec"
              [fromDataView]="fromDataView"
              inMultiList="true"
              (listDisplayed)="onSectionDisplayed($event)"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (contentModified)="onContentModified($event)"
              (listTransactionEvent)="onListTransactionEvent($event)"
              (drillAroundEvent)="onDrillAroundEvent($event)"
          ></lm-list>
        </ng-container>
        <ng-container *ngSwitchCase="'form'">
          <lm-form
            #LMFormComponent
              [formSpec]="section.spec"
              [formUrlInfo]="section.url"
              [formOptions]="formOptions"
              [fromDataView]="fromDataView"
              (formDisplayed)="onSectionDisplayed($event)"
              (sendContextMessageEvent)="onSendContextMessageEvent($event)"
              (contentModified)="onContentModified($event)"
          ></lm-form>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
